module.exports = __webpack_public_path__ + "img/title4.847783cd.png";